import { render, staticRenderFns } from "./ExplorerMembers.vue?vue&type=template&id=2b9882d0&scoped=true&"
import script from "./ExplorerMembers.vue?vue&type=script&lang=js&"
export * from "./ExplorerMembers.vue?vue&type=script&lang=js&"
import style0 from "./ExplorerMembers.vue?vue&type=style&index=0&id=2b9882d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9882d0",
  null
  
)

export default component.exports